import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var defaultParamsToQueryStringSerializer = function defaultParamsToQueryStringSerializer(value) {
  return JSON.stringify(value);
};
var paramsToQueryString = function paramsToQueryString(params) {
  var serialize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultParamsToQueryStringSerializer;
  return Object.keys(params).filter(function (key) {
    return params[key] || params[key] === 0;
  }).map(function (key) {
    return [key, typeof params[key] === 'string' ? params[key] : serialize(params[key])];
  }).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');
};
var sortBundlesParams = function sortBundlesParams(params) {
  return Object.keys(params).sort().reduce(function (prev, curr) {
    return Object.assign(Object.assign({}, prev), _defineProperty({}, curr, params[curr]));
  }, {});
};
export { paramsToQueryString, sortBundlesParams };